import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ palette }) => ({
  container: {
    boxShadow: 'none',
    backgroundColor: palette.grey[100]
  }
}));
